import { createFileRoute } from '@tanstack/react-router'
import OportunidadesListPage from '@/pages/oportunidades/oportunidades-list-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/oportunidades/',
)({
  component: function OportunidadesListRoute() {
    const { dashboardId } = Route.useParams()
    return (
      <ProtectedRoute
        anyOf={[CAPABILITIES.CRM_ALL, CAPABILITIES.CRM_OWN]}
        dashboardId={dashboardId}
      >
        <OportunidadesListPage />
      </ProtectedRoute>
    )
  },
})
